/**
 * organizations sagas
 */
import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import pick from 'lodash.pick';

import axios from 'axios';
import { SagaIterator } from 'redux-saga';
import { updateQueryString } from 'services/router/actions';
import { postRequest } from 'utils/redux-saga';
import { NEW_ORGANIZATION_MODAL } from 'scenes/Organizations/components/NewOrganizationModal';

// Constants
import {
    NEW_ORGANIZATION_REQUESTED,
    ORGANIZATIONS_LOAD_REQUESTED
} from './constants';

// Actions
import {
    failedNewOrganization,
    loadOrganizations,
    organizationsLoaded,
    organizationsLoadingError,
    succeededNewOrganization
} from './actions';
// @ts-ignore
import { enqueueSnackbar } from '../notifications/actions';
// @ts-ignore
import { setSeasons } from '../seasons/actions';

// Selectors
// @ts-ignore
import { idTokenSelector } from '../auth/selectors';

// Types
import { Organization, RequestedNewOrganizationAction } from './types';

// Environment
const { REACT_APP_API_URL } = process.env;

export function* getOrganizations(): any {
    // Select ID Token
    const idToken = yield select(idTokenSelector);

    const url = `${REACT_APP_API_URL}/v1/Organizations`;

    const config = {
        headers: {
            Authorization: idToken
        }
    };

    try {
        const response = yield axios.get(url, config);
        const { data } = response;

        const organizations = data.map(
            ({ seasons, ...organization }: Organization) => organization
        );
        const allSeasons = data.reduce(
            (seasons: Record<string, any>[], organization: Organization) => [
                ...seasons,
                ...organization.seasons
            ],
            []
        );

        // Set Seasons
        yield put(setSeasons(allSeasons));

        // Organizations Loaded
        yield put(organizationsLoaded(organizations));
    } catch (error) {
        // Organizations Loading Error
        yield put(organizationsLoadingError(error));
    }
}

export function* watchLoadOrganizations(): SagaIterator {
    yield takeEvery(ORGANIZATIONS_LOAD_REQUESTED, getOrganizations);
}

export function* requestedAddNewOrganization({
    payload
}: RequestedNewOrganizationAction): SagaIterator {
    try {
        const response = yield call(
            postRequest,
            'Organizations/withConfig',
            pick(payload, [
                'newOrganizationName',
                'sourceOrganizationId',
                'includeTimesheets',
                'includeSpray',
                'includeFertilizer',
                'includeHarvest',
                'organizationType'
            ])
        );

        yield put(
            enqueueSnackbar({
                message: 'New organization has been created successfully',
                options: { variant: 'success' }
            })
        );

        // Update Query String
        yield put(
            updateQueryString({
                [NEW_ORGANIZATION_MODAL]: undefined
            })
        );
        yield put(succeededNewOrganization(response));
        yield put(loadOrganizations());
    } catch (error) {
        yield put(failedNewOrganization(error));
    }
}

export function* watchRequestedNewOrganization(): SagaIterator {
    yield takeLatest(NEW_ORGANIZATION_REQUESTED, requestedAddNewOrganization);
}
